module.exports = __webpack_public_path__ + "static/summary-large-image-637466d2221aa8e26cc1a84ea85f2204.png";